import { BaseListing } from 'craftable';
import FormMixin from '../Mixin';

export default {
	mixins: [BaseListing, FormMixin],
	data: function () {  
        return {
            showFilter: false,
            testDate: null,
            // moduleFilters:{
            //     date_start: null,
            //     date_end: null,
            // },
            orderBy: {
                column: 'created_at',
                direction: 'desc'
            },
        }
    },
	methods:{
		onChangeDateRangeFilter(dateRange){
            if (dateRange) {

                if (dateRange[0] && dateRange[1]) {
                    const startDate = moment(dateRange[0]).startOf('day')
                    const endDate = moment(dateRange[1]).endOf('day')
                    this.moduleFilters.date_start = this.getDateFromString(startDate, null, this.dateFormat.ymdhis, 'utc') 
                    this.moduleFilters.date_end = this.getDateFromString(endDate, null, this.dateFormat.ymdhis, 'utc') 
                }else{
                    this.moduleFilters.date_start =  null
                    this.moduleFilters.date_end = null
                }
            }else{
                this.moduleFilters.date_start =  null
                this.moduleFilters.date_end = null
            }
            this.applyFilters()
        },
        applyFilters(){
            // console.log('this.moduleFilters', this.moduleFilters)
            Object.assign(this.filters, this.moduleFilters);
            // console.log('this.filters', this.filters)
            this.loadData(true)
        }
	}
};